import { checkUsernameReq, userRegistrationReq } from "../../../redux/member-slices/auth.slice"
import { hideDialog, showDialog } from "../../../redux/guest-slices/other.slice"
import { GUEST_LOGIN } from "../../../utils/keywords"
import { useDispatch, useSelector } from "react-redux"
import { useToast } from "../../../hooks/useToast"
import FacebookLogin from "../../ui/FacebookLogin"
import { Link as NavLink } from "react-router-dom"
import GoogleLogin from "../../ui/GoogleLogin"
import Icons from "../../../assets/js/Icons"
import { useState } from "react"

import {
  Box, Button, CircularProgress, DialogContent, DialogTitle, Divider,
  Grid2 as Grid, Icon, IconButton, Link, Paper, Stack, TextField, Tooltip, Typography
} from "@mui/material"

function Signup() {
  const toast = useToast()
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [password, setPassword] = useState(false)
  const [username, setUsername] = useState(null)
  const [usernameError, setUsernameError] = useState(null)
  const { other } = useSelector(state => state.memberSlice)

  // Handle user signup 
  const handleSubmit = (e) => {
    e.preventDefault()

    const form = new FormData(e.target)
    const formData = Object.fromEntries(form)

    if (!formData?.username || !formData?.username?.trim()) {
      setUsernameError("Username is required")
      return toast.error("Username is required!")
    }

    // Prevent submission if username is being checked or has error
    if (other?.loadingUsername) {
      return toast.error("Please wait, checking username availability...")
    }
    if (username === false || usernameError) {
      return toast.error(usernameError || "Username already taken! Please choose a different username.")
    }

    if (
      Object.keys(formData)?.some((field) => {
        const value = formData[field]
        return (value?.trim() === "" || !value)
      })
    ) {
      return toast.error("Please fill all required field!")
    }
    const regularExpression = /^(?=.*[0-9])(?=.*[\W_])[a-zA-Z0-9\W_]{8,16}$/
    if (!regularExpression.test(formData?.password)) {
      return toast.error("Strong password required!")
    }
    if (formData?.password !== formData?.confPassword) {
      return toast.error("Confirm password didn't match!")
    }
    formData.stay = true
    dispatch(userRegistrationReq(formData))
  }

  // handle validate username
  let interval = null
  const validateUsername = (e) => {
    const value = e.target?.value
    const allowedChars = /[^a-z0-9_]/g
    const filteredValue = value.replace(allowedChars, "")
    e.target.value = filteredValue
    clearInterval(interval)
    setUsername(null)
    setUsernameError(null)
    if (filteredValue) {
      interval = setTimeout(() => {
        dispatch(checkUsernameReq({ username: filteredValue })
        ).unwrap().then((res) => {
          setUsername(res?.success)
          setUsernameError(null)
        }).catch((err) => {
          setUsername(err?.response?.data?.success)
          setUsernameError(err?.response?.data?.error || "Username already taken!")
        })
      }, 1000)
    } else {
      setUsernameError("Username is required")
    }
  }

  const handleUsernameBlur = (e) => {
    const value = e?.target?.value
    if (!value || !value.trim()) {
      setUsernameError("Username is required")
      setUsername(null)
    }
  }

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog())
  }

  // Handle signup
  const handleLogin = () => {
    dispatch(showDialog(GUEST_LOGIN))
  }

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >Signup To Post
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "black",
            position: "absolute",
            bgcolor: "#0000001f !important",
          }}
          size="small"
          onClick={handleClose}
        ><Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          "textarea": { resize: "none" },
        }}
      >
        <Box
          component="form"
          onSubmit={handleSubmit}
        >
          <Stack spacing={3}>
            <TextField
              size="small"
              label="Name"
              name="fullName"
              variant="filled"
              varianttype="login"
            />
            <Box>
              <TextField
                size="small"
                name="username"
                label="Username"
                variant="filled"
                autoComplete="off"
                varianttype="login"
                error={Boolean(usernameError || username === false)}
                helperText={usernameError || (username === false ? "Username already taken!" : null)}
                sx={{ width: "100%" }}
                onChange={validateUsername}
                onBlur={handleUsernameBlur}
                slotProps={{
                  input: {
                    endAdornment: other?.loadingUsername ?
                      <CircularProgress
                        size={20}
                        thickness={6}
                      /> :
                      username === true && !usernameError ?
                        <Tooltip title="Username is available">
                          <Icon sx={{ fontSize: "22px", color: "success.main" }}>
                            <Icons.Checkmark />
                          </Icon>
                        </Tooltip> :
                        (username === false || usernameError) ?
                          <Tooltip title={usernameError || "Username already taken!"}>
                            <Icon sx={{ fontSize: "22px", color: "error.main", cursor: "help" }}>
                              <Icons.Alert />
                            </Icon>
                          </Tooltip> : null
                  }
                }}
              />
              {username === true && !usernameError &&
                <Typography
                  mt={0.5}
                  fontSize="14px"
                  color="success.main"
                >Username available!
                </Typography>
              }
            </Box>
            <TextField
              size="small"
              name="email"
              label="Email"
              variant="filled"
              varianttype="login"
            />
            <Box>
              <TextField
                size="small"
                name="password"
                variant="filled"
                varianttype="login"
                sx={{ width: "100%" }}
                label="Create Password"
                type={show ? "text" : "password"}
                onFocus={() => { setPassword(true) }}
                onBlur={() => { setPassword(false) }}
                slotProps={{
                  input: {
                    endAdornment:
                      <IconButton
                        size="small"
                        onClick={() => { setShow(!show) }}
                      >
                        {!show ?
                          <Icons.ViewSolid /> :
                          <Icons.ViewOffSolid />
                        }
                      </IconButton>
                  }
                }}
              />
              {password &&
                <Typography
                  mt={0.5}
                  fontSize="14px"
                  color="warning.main"
                >Password must be 8-16 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*).
                </Typography>
              }
            </Box>
            <TextField
              size="small"
              variant="filled"
              name="confPassword"
              varianttype="login"
              label="Confirm Password"
              type={show1 ? "text" : "password"}
              slotProps={{
                input: {
                  endAdornment:
                    <IconButton
                      size="small"
                      onClick={() => { setShow1(!show1) }}
                    >
                      {!show1 ?
                        <Icons.ViewSolid /> :
                        <Icons.ViewOffSolid />
                      }
                    </IconButton>
                }
              }}
            />
            <Typography
              fontSize={14}
              color="other.color1"
              textAlign="end"
            >
              <Link
                underline="hover"
                component={NavLink}
                to="/forgot-password"
              >Forgot password?
              </Link>
            </Typography>
            <Button
              sx={{
                p: "9px 17px",
                lineHeight: "1.5",
                fontSize: "18px",
                justifyContent: "center",
              }}
              type="submit"
              color="secondary"
              variant="contained"
              disabled={username === false}
              endIcon={
                other?.loadingLogin &&
                <CircularProgress
                  size={22}
                  color="text"
                  thickness={6}
                />
              }
            >Signup
            </Button>
            <Divider>
              <Typography
                component="span"
                sx={{ color: "#d4d4d4" }}
              >Or
              </Typography>
            </Divider>
            <Grid container spacing={1}>
              <Grid size={{ xs: 12, md: 6 }}>
                <FacebookLogin stay={true} />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <GoogleLogin stay={true} />
              </Grid>
            </Grid>
            <Typography
              mb={3}
              color="other.color1"
              textAlign="center"
            >By continuing you indicate that you agree to Quora's to InnerPals <Link
              underline="hover"
              sx={{ mb: "20px" }}
              component={NavLink}
              onClick={handleClose}
              to="/terms-and-conditions"
            > Terms of Service
              </Link> and <Link
                underline="hover"
                to="/privacy-policy"
                sx={{ mb: "20px" }}
                component={NavLink}
                onClick={handleClose}
              > Privacy Policy
              </Link>.
            </Typography>
            <Typography
              mb={3}
              fontSize={14}
              color="other.color1"
              textAlign="center"
            >Already have an account? <Link
              type="button"
              underline="hover"
              component="button"
              onClick={handleLogin}
            >Login</Link>
            </Typography>
          </Stack>
        </Box>
      </DialogContent>
    </Paper>
  )
}

export default Signup